<template>
  <div
    v-if="$store.state.loginUser.curCmpnId !== null"
    id="app">
    <router-view/>
  </div>
</template>

<script>
import './components/icons';
import {EventBus} from './components/common/event-bus';
import axios from 'axios';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import {BROWSER} from "@/constants/constants";
import ENDPOINT from "@/api/endpoints";
import {getValueFromStorageByKey, setValueToStorageByKey, LOCAL_STORAGE_KEY} from '@/util/localStorage';
import {SUPPORTED_LANGUAGE} from '@/constants/trans'
import keycloakService from '@/services/common/keycloak.service';
import urlsConf from '../config/urls.conf'


export default {
  name: 'App',
  data: function() {
    return {
      tokenKey:'',
      LoginInfoCheckedFlag: false
    }
  },
  computed: {
    getLocale: function() {
      return this.$i18n.locale;
    }
  },
  watch: {
    getLocale: function() {
      this.broadcastingLocaleChanged()
    },
  },
  created() {
    this.getApiByEnviroment();
    this.$store.dispatch('common/setBrowser', this.getBrowser());
  },
  methods: {
    getBrowser() {
      if (/Trident\/|MSIE/.test(window.navigator.userAgent)) {
        return BROWSER.IE
      }
      return BROWSER.CHROME
    },
    getApiByEnviroment(){
      axios.get(ENDPOINT.GENERAL_EARTH.FRONT_PROFILE, {
        excludeToken: true
      })
        .then(result => {
          return result.data;
        })
        .then(json => {
          this.profile.env = this.urls.profile = json.env;
          // 개발 / 운영계 별도 토큰 관리
          this.$store.commit('setTokenKey' , this.profile.env === this.constants.DEV ? this.constants.ACCESS_TOKEN_DEV : this.constants.ACCESS_TOKEN );
          this.ssoStart()
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 인증 Start
    ssoStart(){
      const pathname = location.pathname;

      // const tokenKey = this.$store.state.ACCESS_TOKEN_KEY;
      this.tokenKey = this.$store.state.ACCESS_TOKEN_KEY;
      const hash = window.location.hash;
      const redirect_token = this.getQueryParams(this.constants.ACCESS_TOKEN);

      const access_token = this.$cookies.get(this.tokenKey);

      let whiteDomain = this.getWhiteLabelDomain(window.location.hostname)

      this.$store.commit('setSubDomain', whiteDomain)

      // if(redirect_token) {
      //   this.$cookies.set(this.tokenKey, redirect_token.toString(), '1y', '/', typeof(this.$store.state.sub_domain) !== this.constants.UNDEFINED ? this.$store.state.sub_domain : '');
      //   this.$router.push(pathname)
      // }

      // keycloak init
      this.$cookies.remove(this.tokenKey, '/', this.$store.state.sub_domain);
      keycloakService.init(this.urls.openapiUrl).then((keycloak) => {

        // eslint-disable-next-line no-param-reassign
        keycloak.onReady = () => {
          if (!keycloakService.isLoggedIn()) {
            keycloakService.login();
          }
        };

        // 로그인 성공한 후 리다이렉트 될 경우 아래 이벤트 호출됨
        // eslint-disable-next-line no-param-reassign
        keycloak.onAuthSuccess = async () => {
          // console.log('Auth Success =>', keycloak);
          this.$cookies.set(this.tokenKey, keycloak.token, '1y', '/', this.$store.state.sub_domain);
          this.getLoginUser(keycloak.token);
        };

        // eslint-disable-next-line no-param-reassign
        keycloak.onAuthError = () => {
          // console.log('Auth Error');
        };

        // 토큰이 만료될 경우 아래 로직 호출됨 (토큰 갱신)
        // eslint-disable-next-line no-param-reassign
        keycloak.onTokenExpired = () => {
          // console.log('token expired', keycloak.token);
          keycloak.updateToken(5).success(() => {
            this.$cookies.set(this.tokenKey, keycloak.token, '1y', '/', this.$store.state.sub_domain);
            // console.log('successfully get a new token', keycloak.token);
          }).catch(() => {
            // console.error('Failed to refresh token');
            //this.$store.commit('user/SET_TOKEN_EXPIRATION', true);
          });
        };
      });
    },
    trackGAData() {
      window['dataLayer'].push({
        // user id to track individual
        'user_id' : this.$store.state.loginUser.userId,
        // user id
        'crm_id' : this.$store.state.loginUser.userEmail,
        // site name ex) BespinGlobal(OpsNow) or WL
        'site_name' : this.$store.state.loginUser.siteCd,
        // user type ex) free or charge
        'user_type' : this.$store.state.loginUser.chargeType,
        // user company ex) BespinGlobal, SendBird ...
        'user_company' : this.$store.state.loginUser.blntCmpnNm + '(' + this.$store.state.loginUser.blntCmpnId + ')',
      })
    },
    getLoginUser(access_token) {
      let self = this;

      axios.get(ENDPOINT.USER_EARTH.CURRENT_LOGGED_IN).then(result => {
        if(result.data.status === 'ok') {
          if (result.data.result) {
            return result.data.result
          } else {
            this.$cookies.set(this.tokenKey, null, -1,'/', typeof(this.$store.state.sub_domain) !== this.constants.UNDEFINED ? this.$store.state.sub_domain : '')
            keycloakService.logout();
          }
        } else {
          this.$cookies.set(this.tokenKey, null, -1,'/', typeof(this.$store.state.sub_domain) !== this.constants.UNDEFINED ? this.$store.state.sub_domain : '')
          keycloakService.logout();
        }
        // TODO : Trial 처리 나중에
        // if(rsp.result.trialYn == 'Y' && rsp.result.trialRemainDays == 0){
        //     console.log(global['loginUser'],urls.portalUrl )
        //     location.href = `${urls.portalUrl}`
        //     return;
        // }∂
        // if (result.data.result && result.data.result.userId) {
        //     this.$store.commit('setLoginUser', result.data.result)
        // } else {
        //     this.login()
        // }
      })
      .then(json => {
        self.$store.commit("setAccessDenied", false);
        if (json.siteCd === "BESPIN") {
          //MFA 2단계 인증 설정여부
          self.$store.commit("setOtpDenied", false);
          if (json.useOtp === '0') {
              self.$store.commit("setOtpDenied", true);
          }
          // ip 있는지 없는지 체크
          self.$store.commit("setAllowedIpNull", false);
          if (json.allowedIpaddr == null) {
              self.$store.commit("setAllowedIpNull", true);
          }
          // ip addr입력되었을때 ip 유효성 체크
          self.$store.commit("setAllowedIpDenied", false);
          if (json.passIpaddr !== 'Y') {
              self.$store.commit("setAllowedIpDenied", true);
          }
          // 오류가 있으면 로그인 정보를 받아오지 않음.
          if (self.$store.state.accessDenied || self.$store.state.otpDenied || self.$store.state.allowedIpNull || self.$store.state.allowedIpDenied || self.$store.state.loginDeniedConCurrent)
              return;
        }
        self.$store.commit('setLoginUser', json);
        self.LoginInfoCheckedFlag = true;

        //check submitted survey?
        const checkSubmittedSurveyPayload = {
          userId: json.userId,
          userEmail: json.userEmail
        };
        this.$store.dispatch('common/checkSubmittedSurvey', checkSubmittedSurveyPayload);

        this.trackGAData();

        return json;
      })
      .catch(error => {
        if (error.code === '470' || error.code === '406') {
          this.$cookies.set(this.tokenKey, null, -1,'/', typeof(this.$store.state.sub_domain) !== this.constants.UNDEFINED ? this.$store.state.sub_domain : '')
          keycloakService.logout();
        }
        this.$cookies.set(this.tokenKey, null, -1,'/', typeof(this.$store.state.sub_domain) !== this.constants.UNDEFINED ? this.$store.state.sub_domain : '')
        keycloakService.logout();
      })
    },
    getQueryParams(param) {

      var result = window.location.search.match(
        new RegExp("(\\?|&)" + param + "(\\[\\])?=([^&]*)")
      )
      return result ? result[3] : false
    },
    getWhiteLabelDomain(hostname) {
      return '.' + hostname.split('.').slice(1).join('.')
    },
    broadcastingLocaleChanged: function(){
      EventBus.$emit('changeLocale', this.getLocale);
    }
  }
};
</script>

<style lang="scss">
  @import "assets/css/base/index";
  @import '../node_modules/material-icons/iconfont/material-icons.css';
  body {
    scroll-behavior: smooth;
    #app{
      background:#F2F4F6;
      height: calc(100vh - 35px);
      overflow: auto;
      #header {
        position: fixed;
        top: 0px;
      }
      #title {
        position: fixed;
      }
    }
  }
  // Stack Chart 아이콘 z-index 전역처리
  .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active, .btn-group-vertical > .btn:focus, .btn-group-vertical > .btn:active, .btn-group-vertical > .btn.active {
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue